import React from "react";

const Torchie = (): React.ReactElement => {
  return (
    <svg width="40" height="60" viewBox="0 0 118 180" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0)">
        <path
          d="M0 120.4C0 153 26.4 179.4 59 179.4C91.6 179.4 118 153 118 120.4C118 96.4 111.9 87.2 102.6 65.3C97.1 52.2 96.6 37.6 96.6 34.4C96.6 26.6 97.8 22.7 97.8 22.7C97.8 22.7 97.2 22.6 96.4 22.6C95.6 22.6 92.8 22.7 90.3 25.2C86.7 28.8 85.7 34.5 82.8 37C81.2 38.4 77.8 39.1 75.3 36.7C74.2 35.6 72.3 32.6 72.3 26.5C72.3 10.1 80.6 0.199977 80.6 0.199977C80.6 0.199977 79.4 -2.2588e-05 78 -2.2588e-05C76.7 -2.2588e-05 67.1 -0.100023 57 9.89998C45.5 21.5 45.9 45 39.1 51.8C37.6 53.3 34.4 54.1 34.4 51.6C34.4 50.8 35.2 46.6 35.2 41.5C35.2 33.8 33.4 26.7 27.3 20.6C23.5 16.8 20.2 16.1 20.2 16.1C20.2 16.1 21.2 20.4 21.2 26.6C21.2 58 0 81.8 0 120.4Z"
          fill="url(#paint0_linear)"
        />
        <path
          d="M84.9 102.2C89.0421 102.2 92.4 98.8421 92.4 94.7C92.4 90.5579 89.0421 87.2 84.9 87.2C80.7579 87.2 77.4 90.5579 77.4 94.7C77.4 98.8421 80.7579 102.2 84.9 102.2Z"
          fill="#212124"
        />
        <path
          d="M33.1 102.2C37.2421 102.2 40.6 98.8421 40.6 94.7C40.6 90.5579 37.2421 87.2 33.1 87.2C28.9579 87.2 25.6 90.5579 25.6 94.7C25.6 98.8421 28.9579 102.2 33.1 102.2Z"
          fill="#212124"
        />
        <path
          d="M59 149.3C66.3454 149.3 72.3 140.659 72.3 130C72.3 119.341 66.3454 110.7 59 110.7C51.6546 110.7 45.7 119.341 45.7 130C45.7 140.659 51.6546 149.3 59 149.3Z"
          fill="#212124"
        />
        <path
          d="M76 77.8C75.1 77.8 74.2 77.3 73.8 76.5C73.2 75.3 73.6 73.8 74.8 73.1C75 73 79.2 70.8 85.2 70.8C91.3 70.8 95 73.1 95.2 73.2C96.4 73.9 96.7 75.5 96 76.6C95.3 77.8 93.7 78.1 92.6 77.4C92.5 77.4 89.8 75.8 85.3 75.8C80.6 75.8 77.3 77.5 77.3 77.5C76.8 77.7 76.4 77.8 76 77.8Z"
          fill="#212124"
        />
        <path
          d="M24.2 82.4C23.3 82.4 22.4 81.9 22 81.1C21.4 79.9 21.8 78.4 23 77.7C23.2 77.6 27.4 75.4 33.4 75.4C39.5 75.4 43.2 77.7 43.4 77.8C44.6 78.5 44.9 80.1 44.2 81.2C43.5 82.4 41.9 82.7 40.8 82C40.7 82 38 80.4 33.5 80.4C28.8 80.4 25.5 82.1 25.5 82.1C25 82.4 24.6 82.4 24.2 82.4Z"
          fill="#212124"
        />
      </g>
      <defs>
        <linearGradient id="paint0_linear" x1="0" y1="89.6876" x2="118" y2="89.6876" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFC9DE" />
          <stop offset="0.49" stopColor="#DBDBEE" />
          <stop offset="1" stopColor="#B5EDFF" />
        </linearGradient>
        <clipPath id="clip0">
          <rect width="118" height="179.4" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Torchie;
